const state = {
	summary_company: "",
	//loading: false,
};

const getters = {
	getSummaryCompany: (state) => {
		return state.summary_company;
	},
	
};

const mutations = {
	updateSummaryCompany: (state, payload) => {
		state.summary_company = payload;
		console.log('Store update called - ' + payload);
	},
	clearAll: (state, payload) => {
		state.summary_company = "";
		
	},
	isLoading: (state, payload) => {
		state.loading = payload;
	},
};

const actions = {
	
	setSummaryCompany: ({ commit }, req) => {
		commit('updateSummaryCompany',req);
		
		
	},
	
};

export default {
	state,
	mutations,
	getters,
	actions,
};
